import React from "react"
import { FieldArray, FormikProps } from "formik"
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton"
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField"
import { ContactInfoFormValues } from "src/models/ContactInfo.model"
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea"
import { GrFormAdd } from "react-icons/gr"
import { RiDeleteBin5Line } from "react-icons/ri"
import { getInputHeight } from "src/utils/formUtils/getInputHeight"

type Props = {
  formikProps: FormikProps<ContactInfoFormValues>
  onClose: () => void
  formType: "ADD" | "EDIT"
}

const ContactInfoForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps

  return (
    <div className="p-4 flex flex-col gap-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Contact" : "Update Contact"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>

      {/* Form Fields */}
      <div className="flex flex-col gap-4">
        {/* Phone Numbers */}
        <FieldArray name="content[0].phoneNumber">
          {({ push, remove }) => (
            <>
              {values.content[0].phoneNumber ? (
                values.content[0].phoneNumber.map((phone, index) => (
                  <div key={index} className="flex gap-2 items-end mb-2">
                    {/* Phone Number Field */}
                    <div className="flex-1">
                      <ATMTextField
                        key={index}
                        name={`content[0].phoneNumber[${index}]`}
                        value={phone}
                        onChange={(e) =>
                          setFieldValue(
                            `content[0].phoneNumber[${index}]`,
                            e.target.value
                          )
                        }
                        placeholder="Enter phone number"
                        label={`Phone Number ${index + 1}`}
                        required
                        onBlur={handleBlur}
                      />
                    </div>

                    {/* Delete Button */}
                    <button
                      type="button"
                      className={`${getInputHeight(
                        "small"
                      )} aspect-square rounded bg-red-400 text-white flex justify-center items-center`}
                      onClick={() => remove(index)}
                    >
                      <RiDeleteBin5Line size={20} />
                    </button>
                  </div>
                ))
              ) : (
                <p>No phone numbers added</p>
              )}

              {/* Add Button */}
              <div className="flex justify-end mt-2">
                <button
                  type="button"
                  onClick={() => push("")}
                  className="rounded border-dashed border border-slate-500 font-medium text-md text-gray-500 flex items-center gap-1 px-3 py-1 hover:bg-gray-50"
                >
                  Add{" "}
                  {values?.content[0]?.phoneNumber
                    ? "More Contacts"
                    : "Phone Number"}
                  <GrFormAdd
                    color="#6b7280"
                    size="1.5em"
                    className="font-semibold"
                  />
                </button>
              </div>
            </>
          )}
        </FieldArray>

        {/* Address */}
        <div>
          <ATMTextArea
            name="content[0].address"
            required
            value={values.content?.[0]?.address || ""}
            onChange={(e) => {
              setFieldValue("content[0].address", e)
            }}
            label="Address"
          />
        </div>
      </div>

      {/* Submit Button */}
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  )
}

export default ContactInfoForm
